// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"601846e2","96":"04cd35db","401":"e6001e0d","787":"0944a889"}[chunkId] + ".chunk.js";
};